import React, { Component } from 'react';
import { postPotentialDomesticCarrierRegistrationForm } from '../../../apis/forms';
import { getCountries, getStatesByCountryId } from '../../../apis/locale';
import toast from '../../../components/toast';
import animatedScrollTo from 'animated-scroll-to';
import { yearsInBusiness, yesNo, currencies } from '../../../helpers/shared-form-data.json';
import kebabCase from 'lodash/kebabCase';
import BaseSelect from 'react-select';
import RequiredSelect from './required-select.jsx';
import { addParamsToUrl } from '../../../utils/';
import ReCAPTCHA from "react-google-recaptcha";

const Select = props => (
    <RequiredSelect
        {...props}
        SelectComponent={BaseSelect}
        options={props.options || options}
    />
);

const initialState = {
    company: '',
    country: 'US',
    state: 'AL',
    city: '',
    addressLine1: '',
    addressLine2: '',
    postalCode: '',
    websiteURL: '',
    salesPersonName: '',
    salesPersonPhone: '',
    salesPersonEmail: '',
    assetBased: '',
    yearsInBusiness: '',
    dotNumber: '',
    annualRevenue: '',
    annualRevenueCurrency: currencies[0],
    authorityType: '',
    service: '',
    statesService: '',
    safetyRating: '',
    companyServices: '',
    apartFromCompetition: '',
    recaptchaToken: ''
};

class PotentialCarrierRegistration extends Component {
    constructor(props) {
        super(props);

        this.state = Object.assign({}, initialState, {
            isSending: false,
            countries: [],
            states: [],
            usStates: [],
            usStateOptions: [],
            selectedStates: [],
            errors: []
        });

        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleStateServiceChange = this.handleStateServiceChange.bind(this);

        this.form = React.createRef();
        this.recaptchaRef = React.createRef();
    }

    componentDidMount() {
        this.loadCountries();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.country !== this.state.country && this.state.country) {
            this.loadStates();
        }
    }

    loadCountries() {
        getCountries()
            .then(data => {
                this.setState({
                    countries: data
                }, () => {
                    if(this.state.country) this.loadStates(), this.loadUSStates();
                });
            });
    }

    loadStates() {
        this.setState({
            states: []
        });
        const country = this.state.countries.find(c => c.countryTwoLetterCode === this.state.country);
        getStatesByCountryId(country.countryID)
            .then(data => {
                this.setState({
                    states: data
                });
            });
    }

    loadUSStates() {
        const us = this.state.countries.find(c => c.countryTwoLetterCode === 'US');
        getStatesByCountryId(us.countryID)
            .then(data => {
                this.setState({
                    usStates: data,
                    usStateOptions: data.map(state => {
                        return {
                            label: state.stateDisplayName,
                            value: state.stateCode
                        };
                    })
                });
            });
    }

    handleFormSubmit(e) {
        e.preventDefault();

        if (!this.state.isSending) {
            this.setState({
                isSending: true,
                errors: [],
                recaptchaToken: this.recaptchaRef.current.getValue()
            }, () => {

            // send form to api
            postPotentialDomesticCarrierRegistrationForm(Object.assign({}, this.state))
                .then(json => {
                    console.log(json);
                    this.setState({
                        isSending: false
                    });

                    if (json.success) {
                        toast.success('Your registration has been submitted!');
                        if (this.props.redirectTo) window.location = this.props.redirectTo;
                        else {
                            this.form.current.reset();
                            this.setState(Object.assign({}, initialState));
                            this.setState({
                                selectedStates: []
                            });
                        }
                    }
                    else {
                        this.setState({
                            errors: json.errors
                        });
                        animatedScrollTo(document.querySelector('#carrier-registration-form'));
                    }
                })
                .catch(error => {
                    this.setState({
                        isSending: false
                    });
                    console.log(error);
                    toast.error('There was an issue sending your registration. Please try again soon.');
                });
            });
        }
    }

    handleChange(e) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            errors: []
        });
    }

    handleStateServiceChange(selectedStates) {
        this.setState({
            selectedStates,
            statesService: selectedStates.map(s => s.label).join(', ')
        });
    }

    render() {
        let states,
            errors;
        if (this.state.states.length) {
            states = <div className="form-group col-lg-2 col-md-6">
                <label htmlFor="state">State *</label>
                <select className="form-control" id="state" name="state" required value={this.state.state} onChange={this.handleChange}>
                    {this.state.states.map((state) => (
                        <option value={state.stateCode}>{state.stateCode}</option>
                    ))}
                </select>
            </div>;
        }
        if (this.state.errors.length) {
            errors = <ul className="error-list">
                {this.state.errors.map((error) => (
                    <li>{error}</li>    
                ))}
            </ul>;
        }

        return (
            <form id="carrier-registration-form" action="#" method="post" onSubmit={this.handleFormSubmit} ref={this.form}>
                {errors}
                <div className="row">
                    <div className="form-group col-md-12">
                        <label htmlFor="company">Company Name *</label>
                        <input className="form-control" type="text" id="company" name="company" placeholder="Acme Studios" required value={this.state.company} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="streetAddress">Street Address *</label>
                        <input className="form-control" type="text" id="streetAddress" name="addressLine1" placeholder="123 East St." required value={this.state.addressLine1} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="addressLine2">Address Line 2</label>
                        <input className="form-control" type="text" id="addressLine2" name="addressLine2" placeholder="Ste. 5" value={this.state.addressLine2} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-lg-4 col-md-6">
                        <label htmlFor="city">City *</label>
                        <input className="form-control" type="text" id="city" name="city" placeholder="Sheboygan" required="" value={this.state.city} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-lg-4 col-md-6">
                        <label htmlFor="country">Country *</label>
                        <select className="form-control" id="country" name="country" required value={this.state.country} onChange={this.handleChange}>
                            {this.state.countries.map((country) => (
                                <option value={country.countryTwoLetterCode}>{country.countryDisplayName}</option>    
                            ))}
                        </select>
                    </div>
                    {states}
                    <div className="form-group col-lg-2 col-md-6">
                        <label htmlFor="postalCode">Postal Code *</label>
                        <input className="form-control" type="text" id="postalCode" name="postalCode" placeholder="12345" required="" value={this.state.postalCode} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="websiteURL">Website URL</label>
                        <input className="form-control" type="url" id="websiteURL" name="websiteURL" placeholder="https://mywebsite.com" value={this.state.websiteURL} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="salesPersonName">Sales Person Name *</label>
                        <input className="form-control" type="text" id="salesPersonName" name="salesPersonName" placeholder="John Doe" required value={this.state.salesPersonName} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="salesPersonEmail">Sales Person Email *</label>
                        <input className="form-control" type="email" id="salesPersonEmail" name="salesPersonEmail" placeholder="johndoe@gmail.com" required value={this.state.salesPersonEmail} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="salesPersonPhone">Sales Person Phone *</label>
                        <input className="form-control" type="tel" id="salesPersonPhone" name="salesPersonPhone" placeholder="123-123-1234" required value={this.state.salesPersonPhone} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-12">
                        <span className="label">Is your company asset based? *</span>
                        <ul className="radio-list">
                            {yesNo.map((item) => (
                                <li>
                                    <input className="custom-radio" id={`assetBased${kebabCase(item)}`} name="assetBased" type="radio" required value={item} onChange={this.handleChange} />
                                    <label htmlFor={`assetBased${kebabCase(item)}`}>{item}</label>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="yearsInBusiness">Years In Business *</label>
                        <select className="form-control" required id="yearsInBusiness" name="yearsInBusiness" value={this.state.yearsInBusiness} onChange={this.handleChange}>
                            {yearsInBusiness.map((item) => (
                                <option value={item}>{item}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="dotNumber">DOT Number *</label>
                        <input className="form-control" type="text" id="dotNumber" name="dotNumber" placeholder="" required value={this.state.dotNumber} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="annualRevenue">Annual Revenue (Numbers only) *</label>
                        <input className="form-control" type="number" id="annualRevenue" name="annualRevenue" placeholder="" required value={this.state.annualRevenue} onChange={this.handleChange} />
                        <select className="form-control" id="annualRevenueCurrency" name="annualRevenueCurrency" value={this.state.annualRevenueCurrency} onChange={this.handleChange}>
                            {currencies.map((item) => (
                                <option value={item}>{item}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="authorityType">Authority Type *</label>
                        <select className="form-control" required id="authorityType" name="authorityType" value={this.state.authorityType} onChange={this.handleChange}>
                            <option value="Common">Common</option>
                            <option value="Contract">Contract</option>
                            <option value="Broker">Broker</option>
                        </select>
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="service">Do you provide National or Regional service? *</label>
                        <select className="form-control" required id="service" name="service" value={this.state.service} onChange={this.handleChange}>
                            <option value="National">National</option>
                            <option value="Regional">Regional</option>
                        </select>
                    </div>
                    <div className="form-group col-md-12">
                        <label>Select the US States your company provides service in (Select all that apply) *</label>
                        <Select
                            isMulti
                            value={this.state.selectedStates}
                            onChange={this.handleStateServiceChange}
                            options={this.state.usStateOptions}
                            required
                        />
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="safetyRating">Safety Rating *</label>
                        <select className="form-control" required id="safetyRating" name="safetyRating" value={this.state.safetyRating} onChange={this.handleChange}>
                            <option value="Satisfactory">Satisfactory</option>
                            <option value="Conditional">Conditional</option>
                            <option value="Not Applicable">Not Applicable</option>
                        </select>
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="companyServices">Elaborate further on your company's services. *</label>
                        <textarea className="form-control" id="companyServices" name="companyServices" placeholder="" rows="3" required value={this.state.companyServices} onChange={this.handleChange}/>
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="apartFromCompetition">What abilities does your company have that sets you apart from your competition? </label>
                        <textarea className="form-control" id="apartFromCompetition" name="apartFromCompetition" placeholder="" rows="3" value={this.state.apartFromCompetition} onChange={this.handleChange}/>
                    </div>
                </div>
                <ReCAPTCHA
                    sitekey="6LcOndkZAAAAAE7Hb968THW1Zyjt3MGCcF4R2NHQ"
                    ref={this.recaptchaRef}
                />
                <div className="form-actions">
                    <button className="btn" disabled={this.state.isSending}>Send</button>
                </div>
            </form>
        );
    }
}

export default PotentialCarrierRegistration;